import { createExcelAndDownload } from '../../../../utils/reportExcelExport';

export function Reportinvoice(vouchers) {
    const customHeadings = [
        { key: "invoice_no", label: "Voucher No" },
        {key:"memberId",label:"Member ID"},
        {key:"member_id.name",label:"Member Name"},
        {key:"member_id.phone",label:"Contact No"},
        { key: "voucher_date", label: "Voucher Date", isDate: true },
        { key: "invoice.due_date", label: "Due Date", isDate: true },
        { key: "invoice.payment_date", label: "Paid Date", isDate: true },
        { key: "invoice.total_amount", label: "Total Amount" },
        { key: "invoice.discount", label: "Discount" },
        { key: "voucher_type", label: "Voucher Type" },
        { key: "paid_amount", label: "Paid Amount" },
        { key: "reference_number", label: "Payment Reference" },
        { key: "invoice.payment_status", label: "Status" },
    ];

    const formattedVouchers = vouchers.map(voucher => ({
        ...voucher,
        memberId : voucher?.location_id?.member_id_temp + voucher?.member_id?.member_id 
    }));
    createExcelAndDownload("All Member Invoices Report", formattedVouchers, customHeadings);
}
